/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
import React, { Suspense, lazy, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";
// import { checkPrivilege } from "../CommonMethods/checkPrivilege";
import AnimatedPage from "../components/Animation/AnimatedPage";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/components/ForgotPassword";
import SetNewPassword from "../pages/auth/components/SetNewPassword";
// import PasswordChanged from "../pages/auth/components/PasswordChanged";
import Sidebar from "../pages/auth/components/Sidebar";
import AddAdminUser from "../pages/manageAdminUser/components/AddAdminUser";
import Layout from "../../src/components/Layout";
import ViewAdminList from "../pages/manageAdminUser/components/ViewAdminList";
import ManageAdminUsers from "../pages/manageAdminUser";
import Totp from "../pages/auth/components/Totp"
import ManageMerchants from "../pages/ManageMerchants";
import ViewMerchantList from "../pages/ManageMerchants/components/ViewMerchantList"
import OnboardMerchant from "../pages/ManageMerchants/components/OnboardMerchant";
import ViewMerchantDetails from "../pages/ManageMerchants/components/ViewMerchantDetails";
import Noroute from "../pages/auth/components/HandleNORoute";
import AddStores from "../pages/ManageMerchants/components/AddStores";
import AddEmployee from "../pages/ManageMerchants/components/AddEmployee";
import SupportTickets from "../pages/SupportTickets/SupportTickets";
import SingleSupportTicket from "../pages/SupportTickets/SingleSupportTicket";
import BulkStore from "../pages/ManageMerchants/components/BulkUpload/BulkStore";
import BulkEmployee from "../pages/ManageMerchants/components/BulkUpload/BulkEmployee";
import CustomerOrders from "../pages/OrdersAndPurchase";
import ViewOrders from "../pages/OrdersAndPurchase/ViewOrders/ViewOrders";
import CryptoSettlements from "../pages/CryptoSettlements";
import ViewSettlement from "../pages/CryptoSettlements/ViewSettlement";
import { addPrivileges } from "../pages/auth/privilagesSlice";
import { updateUserDetails } from "../pages/auth/authSlice";
import Dashboard from "../pages/Dashboard";
import ManageCustomers from "../pages/ManageCustomers";
import PageLoader from "../components/PageLoader";
import UpdatePassword from "../pages/auth/components/UpdatePassword";

/**
 * Main navigation routes component for admin application
 * 
 * Handles route configuration, authentication, and privilege-based access control.
 * Fixed missing location variable that was causing routing failures and "not found" errors.
 * 
 * @param {Object} props - Component props
 */
export default function NavigationRoutes(props) {
    const [loading, setloading] = useState(true);
    const auth = useSelector((state) => state.auth);
    const { loggedIn, user_name } = auth;
    const dispatch = useDispatch();
    const { param1 } = useParams();
    const navigate = useNavigate();
    const location = useLocation(); // Required for React Router Routes component
    const privileges = useSelector(state => state.Privilages.privileges)
    const initialPaths = {
        "view_dashboard": "/dashboard",
        "admin_user_list": "/manage-admin-users",
        "merchant_list": "/manage-merchants",
        'customer_list': "/customers",
        "order_list": "/orders-purchases",
        "support_request_list": "/supports",
        "settlement_list": "/settlements",
        "password_update": "/password-update"
    };
    const getObjectKey = (obj, value) => Object.keys(obj).find(key => obj[key] === value);
    const routeCheker = (privilege, obj) => {
        for (let key in obj) {
            if (obj[key] && privilege.hasOwnProperty(key)) {
                return obj[key];
            }
        }
        return null; // If no matching key is found
    }
    function processPermissions(permissionsString, previousPrivileges = {}) {
        if (!permissionsString || typeof permissionsString !== 'string') {
            return previousPrivileges; // Return previous state if input is invalid
        }
        const processedPermissions = permissionsString.split(',')
            .map(permission => permission.trim()) // Remove leading/trailing whitespace
            .reduce((acc, permission) => ({ ...acc, [permission]: true }), {});
        return { ...previousPrivileges, ...processedPermissions };
    }
    function getMainRoute(url) {
        const urlObject = new URL(url);
        const path = urlObject.pathname.trim();

        // If path is empty or just a "/", assign the default route
        if (path === '/' || path === '') {
            return 'manage-admin-users';
        }

        // Extract the main route
        const mainRoute = path.split('/')[1];

        return mainRoute;
    }
    const getData = async () => {
        setloading(true);
        try {
            const response = await Auth.currentAuthenticatedUser({ bypassCache: true });
            dispatch(addPrivileges(response?.attributes?.['custom:admin_privileges']))
            let res = processPermissions(response.attributes?.['custom:admin_privileges'])
            let currentUrl = window.location.href;
            const mainRoute = '/' + getMainRoute(currentUrl);
            const routePrivilege = getObjectKey(initialPaths, mainRoute);
            if (!(res.hasOwnProperty(routePrivilege) && res[routePrivilege])) {
                const path = routeCheker(res, initialPaths)
                navigate(path)
            }
            dispatch(updateUserDetails(response?.attributes?.['name']))
            setloading(false);
        } catch (error) {
            setloading(false)
        }

    }
    const checkPrivilege = (privilegeToBeChecked) => {
        if (privileges.hasOwnProperty(privilegeToBeChecked) && privileges.hasOwnProperty) {
            return true;
        } else {
            return false;
        }
    }
    useEffect(() => {
        getData();
    }, [])
    return (
        <Suspense fallback={<div>Loading...</div>}>
            {loading ? <Routes location={location}><Route path="*" element={<PageLoader />} /></Routes> : !loading && (
                <>
                    <Routes location={location}>
                        {!loggedIn ? (
                            <>
                                <Route
                                    path={"/login"}
                                    element={
                                        <AnimatedPage>
                                            <Login />
                                        </AnimatedPage>
                                    }
                                />
                                <Route
                                    path={"/"}
                                    element={
                                        <AnimatedPage>
                                            <Login />
                                        </AnimatedPage>
                                    }
                                />
                                <Route
                                    path={"/forgot-password"}
                                    element={
                                        <AnimatedPage>
                                            <ForgotPassword />
                                        </AnimatedPage>
                                    }
                                />
                                <Route
                                    path={"/set-new-password"}
                                    element={
                                        <AnimatedPage>
                                            <SetNewPassword />
                                        </AnimatedPage>
                                    }
                                />
                                {/* <Route
                                    path={"/passwordchanged"}
                                    element={
                                        <AnimatedPage>
                                            <PasswordChanged />
                                        </AnimatedPage>
                                    }
                                /> */}
                                <Route
                                    path={"/sidebar"}
                                    element={
                                        <AnimatedPage>
                                            <Sidebar />
                                        </AnimatedPage>
                                    }
                                />
                                <Route
                                    path={"/viewadminlist"}
                                    element={
                                        <AnimatedPage>
                                            <ViewAdminList />
                                        </AnimatedPage>
                                    }
                                />
                                <Route
                                    path={"/addadminuser"}
                                    element={
                                        <AnimatedPage>
                                            <AddAdminUser />
                                        </AnimatedPage>
                                    }
                                />


                            </>
                        ) : (
                            <Route element={<Layout {...props} />} key={location}>
                                {checkPrivilege('add_admin_user') && <Route
                                    path={"/manage-admin-users/create"}
                                    element={<AddAdminUser />}
                                />}
                                {checkPrivilege('admin_user_list') && <Route path={"/"} element={<ManageAdminUsers />} />}
                                {checkPrivilege('admin_user_list') && <Route path={"/manage-admin-users"} element={<ManageAdminUsers />} />}
                                {checkPrivilege('update_admin_user') && <Route path={"/manage-admin-users/:id/edit"} element={<AddAdminUser edit />} />}
                                {checkPrivilege('merchant_list') && <Route path={"/manage-merchants"} element={<ManageMerchants />} />}
                                {checkPrivilege('customer_list') && <Route path={"/customers"} element={<ManageCustomers />} />}
                                {checkPrivilege('onboard_merchant') && <Route path={"/manage-merchants/create"} element={<OnboardMerchant />} />}
                                {checkPrivilege('update_merchant') && <Route path={"/manage-merchants/:email/edit"} element={<OnboardMerchant edit />} />}
                                {checkPrivilege('view_merchant') && <Route path={"/manage-merchants/:email/view"} element={<ViewMerchantDetails />} />}
                                {checkPrivilege('add_store') && <Route path={"/manage-merchant/:email/add-store"} element={<AddStores />} />}
                                {checkPrivilege('store_list') && <Route path={"/manage-merchants/:email/import-store"} element={<BulkStore />} />}
                                {checkPrivilege('add_employee') && <Route path={"/manage-merchants/:email/:id/add-employee"} element={<AddEmployee />} />}
                                {checkPrivilege('employee_list') && <Route path={"/manage-merchants/:email/import-employee"} element={<BulkEmployee />} />}
                                {checkPrivilege('update_employee') && <Route path={"/manage-merchants/:email/edit-employee/:id"} element={<AddEmployee edit />} />}
                                {checkPrivilege('add_store') && <Route path={"/manage-merchants/:merchant_email/add-store"} element={<AddStores />} />}
                                {checkPrivilege('update_store') && <Route path={"/manage-merchants/:email/:merchant_email/edit-store"} element={<AddStores edit />} />}
                                {checkPrivilege('support_request_list') && <Route path={"/supports"} element={<SupportTickets />} />}
                                {checkPrivilege('view_support_request') && <Route path={"/supports/view/:id"} element={<SingleSupportTicket />} />}
                                {checkPrivilege('order_list') && <Route path={"/orders-purchases"} element={<CustomerOrders />} />}
                                {checkPrivilege('view_order') && <Route path={"/orders-purchases/:id"} element={<ViewOrders />} />}
                                {checkPrivilege('settlement_list') && <Route path={"/settlements"} element={<CryptoSettlements />} />}
                                {checkPrivilege('view_settlement') && <Route path={"/settlements/:cycleId"} element={<ViewSettlement />} />}
                                {checkPrivilege('view_dashboard') && <Route path={"/dashboard"} element={<Dashboard />}/>}
                                {<Route path={"/password-update"} element={<UpdatePassword />}/>}

                            </Route>
                        )}

                        <Route path="*" element={<Noroute />} />
                    </Routes>
                </>
            )
            }
        </Suspense >
    );
}
